import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { API } from "@/data/site";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get("session_id");
    window.history.replaceState(null, "", location.pathname);
    axios
      .post(`${API}/auth/session`, { session_id: sessionId }, { withCredentials: true })
      .then((res) => navigate("/appointments", { replace: true, state: { user: res.data } }))
      .catch((err) =>
        navigate("/appointments", { replace: true, state: { denied: err.response?.status === 403 } })
      );
  }, [location, navigate]);

  return <main className="min-h-screen bg-ivory" data-testid="auth-callback" />;
}
